import { ENV } from "../utils";

export class GeiEmissionFactor {
  baseApi = ENV.BASE_API;

  async getFactorsBySite(accessToken, siteId) {
    try {
      const url = `${this.baseApi}/gei-emission-factors/site/${siteId}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async initializeDefaultFactors(accessToken, siteId) {
    try {
      const url = `${this.baseApi}/gei-emission-factors/initialize/${siteId}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateFactor(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/gei-emission-factors/${id}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async resetToDefaults(accessToken, siteId) {
    try {
      const url = `${this.baseApi}/gei-emission-factors/reset/${siteId}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
